import {useTranslation} from "react-i18next";

interface Props {
    code?: string;
    text?: string;
}
export const NotFount = ({code, text}: Props) => {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    return (
        <div className={'flex flex-col h-[75vh] justify-center items-center'}>
            <h1 className={'text-[150px]'}>{code}</h1>
            <h3>{text ? text : t('page-not-fount')}</h3>
        </div>
    )
}